<template>
  <img
    src="/images/front/verify-account.png"
    class="mt-20 h-44 w-44"
    alt="Jobful"
  />

  <h2 class="mt-4 text-2xl font-bold text-gray-900">
    {{ __("Your account has been created. Please verify your email for your application to be considered.")}}
  </h2>

  <p class="mt-4 text-sm text-gray-600">
    {{ __("The confirmation code was sent to your email ")}}
        <strong>{{ maskedEmail(successMessage.email) }}</strong>
  </p>
  <a href="/login" target="_BLANK">
    <Button
      class="flex items-center justify-center gap-1.5 mb-14 mt-8"
      style="width: 10rem !important"
    >
      <span>{{ __('Go to Log In') }}</span>
    </Button>
  </a>

</template>
<script setup>
  import { __ } from '../../../../helpers';
  import { Button } from '../../../../components/block/button';

  const emit = defineEmits(['close']);

  defineProps({
    successMessage: Object
  });

  const maskedEmail = (email) => {
    if (!email) return '';
    const parts = email.split('@');
    return parts[0].slice(0, 2) + '***@' + parts[1];
  };
</script>
